//libs
import { useContext } from "react";
import { Navigate } from "react-router-dom";
//context
import { AuthContext } from "context/useAuth";

export default function ProtectedRoute({ children }) {
  const { token } = useContext(AuthContext);

  if (!token) return <Navigate to="/login" />;
  return <>{children}</>;
}
